<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import store from "@/state/store";
import ConfirmationModal from "@/components/confirmationModal";
import ChangePasswordModal from "@/components/changePasswordModal";
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Izmena objekta",
  },
  components: { ErrorAlert, Layout, ConfirmationModal, ChangePasswordModal },
  async created() {
    if (!this.$route.params.id) {
      store.commit("errorBag/RECORD", { status: ["Company not found."] });
      this.disabled = true;
      return;
    }
    this.$store.commit("loader/START_LOADING");

    await axios
      .get(`/super-admin/administrators/${this.$route.params.id}`)
      .then((response) => {
        this.partner_id = response.data.partner_id ?? "";
        (this.company_id = response.data.company_id ?? ""),
          (this.company_name = response.data.company_name ?? ""),
          (this.limit = response.data.limit ?? "");
        this.registrator = response.data.registrator ?? "";
        this.warehouse = response.data.warehouse ?? "";
        this.email = response.data.user.email ?? "";
        this.rebate = response.data.rebate ?? "";
        this.show_prices_to_employees = response.data.show_prices_to_employees
          ? true
          : false;
        this.show_codes_to_employees = response.data.show_codes_to_employees
          ? true
          : false;
        this.show_ids_to_employees = response.data.show_ids_to_employees
          ? true
          : false;
        this.show_limit_to_employees = response.data.show_limit_to_employees
          ? true
          : false;
        this.show_rebate_to_employees = response.data.show_rebate_to_employees
          ? true
          : false;
        this.show_price_with_rebate_to_employees = response.data
          .show_price_with_rebate_to_employees
          ? true
          : false;
        this.show_number_in_package_to_employees = response.data
          .show_package_to_employees
          ? true
          : false;
        this.show_jm_to_employees = response.data.show_jm_to_employees
          ? true
          : false;
        this.narudzbenica_include_group = response.data
          .narudzbenica_include_group
          ? true
          : false;
        this.narudzbenica_include_object_code = response.data
          .narudzbenica_include_object_code
          ? true
          : false;
        this.narudzbenica_include_object_name = response.data
          .narudzbenica_include_object_name
          ? true
          : false;
        this.is_ariba_enabled = response.data.is_ariba_enabled ? true : false;
        this.ariba_buyer_anid = response.data.ariba_buyer_anid ?? "";
        this.classification_domain_app = response.data.classification_domain_app ?? "";
        this.classification_domain_ariba = response.data.classification_domain_ariba ?? "";

        response.data.pricelists.length > 0 &&
          (this.pricelist = response.data.pricelists[0].name);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          store.commit("errorBag/RECORD", {
            status: ["Administrator not found."],
          });
          this.disabled = true;
        }
      })
      .finally(() => this.$store.commit("loader/END_LOADING"));
  },
  methods: {
    cancel() {
      this.$router.push(`/super-admin/administrators`);
    },
    async submitForm() {
      this.$store.commit("loader/START_LOADING");

      try {
        const req = {
          partner_id: this.partner_id,
          company_id: this.company_id,
          company_name: this.company_name,
          email: this.email,
          show_prices_to_employees: this.show_prices_to_employees,
          show_codes_to_employees: this.show_codes_to_employees,
          show_ids_to_employees: this.show_ids_to_employees,
          show_limit_to_employees: this.show_limit_to_employees,
          show_rebate_to_employees: this.show_rebate_to_employees,
          show_price_with_rebate_to_employees: this
            .show_price_with_rebate_to_employees,
          show_package_to_employees: this.show_number_in_package_to_employees,
          show_jm_to_employees: this.show_jm_to_employees,
          pricelists: [this.pricelist],
          registrator: this.registrator,
          warehouse: this.warehouse,
          narudzbenica_include_group: this.narudzbenica_include_group,
          narudzbenica_include_object_code: this
            .narudzbenica_include_object_code,
          narudzbenica_include_object_name: this
            .narudzbenica_include_object_name,
          is_ariba_enabled: this.is_ariba_enabled,
          ariba_buyer_anid: this.ariba_buyer_anid,
          classification_domain_app: this.classification_domain_app,
          classification_domain_ariba: this.classification_domain_ariba,
        };

        if (this.rebate) req["rebate"] = this.rebate;

        await axios.put(
          `/super-admin/administrators/${this.$route.params.id}`,
          req,
        );
        toast("Uspešna izmena firme.", variants.SUCCESS);
        this.cancel();
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
    async deleteAdministrator() {
      this.$store.commit("loader/START_LOADING");

      try {
        await axios.delete(
          `/super-admin/administrators/${this.$route.params.id}`,
        );
        toast("Uspešno brisanje firme.", variants.SUCCESS);
        this.cancel();
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit("loader/END_LOADING");
      }
    },
  },
  data() {
    return {
      disabled: false,
      partner_id: "",
      company_id: "",
      company_name: "",
      registrator: "",
      warehouse: "",
      limit: "",
      rebate: "",
      email: "",
      show_prices_to_employees: false,
      show_codes_to_employees: false,
      show_ids_to_employees: false,
      show_limit_to_employees: false,
      show_rebate_to_employees: false,
      show_price_with_rebate_to_employees: false,
      show_number_in_package_to_employees: false,
      show_jm_to_employees: false,
      pricelist: "",
      narudzbenica_include_object_name: false,
      narudzbenica_include_object_code: false,
      narudzbenica_include_group: false,
      is_ariba_enabled: false,
      ariba_buyer_anid: "",
      classification_domain_app: "",
      classification_domain_ariba: "",
    };
  },
};
</script>

<template>
  <Layout>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">
        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Id partnera
              </label>
              <b-form-input
                v-model="partner_id"
                disabled
                id="administrator-partner-id-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label>
                PIB
              </label>
              <b-form-input
                v-model="company_id"
                :disabled="disabled"
                id="administrator-company-id-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Naziv firme
              </label>
              <b-form-input
                v-model="company_name"
                :disabled="disabled"
                id="administrator-company-name-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Magacin
              </label>
              <b-form-input
                v-model="warehouse"
                :disabled="disabled"
                id="administrator-warehouse-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Registrator
              </label>
              <b-form-input
                v-model="registrator"
                :disabled="disabled"
                id="administrator-registrator-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Rabat (%):
              </label>
              <b-form-input
                v-model="rebate"
                placeholder=""
                id="administrator-limit-input"
                type="number"
                :max="100"
                :min="0"
              ></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Email
              </label>
              <b-form-input
                v-model="email"
                :disabled="disabled"
                placeholder=""
                id="administrator-name-input"
                type="text"
              ></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Cenovnik
              </label>
              <b-form-input
                v-model="pricelist"
                :disabled="disabled"
                placeholder=""
                id="pricelist-name-input"
                type="text"
              ></b-form-input>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_prices_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži cenu objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_codes_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži šifru objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_ids_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži id objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_limit_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži limit objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_price_with_rebate_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži cenu sa rabatom objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_rebate_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži rabat objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_number_in_package_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži broj komada u pakovanju objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="show_jm_to_employees"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži jedinicu mere objektima
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                v-model="narudzbenica_include_group"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži ime grupe u polju "narudžbenica"
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                v-model="narudzbenica_include_object_code"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži šifru objekta u polju "narudžbenica"
              </b-form-checkbox>
            </div>
            <div class="form-group">
              <b-form-checkbox
                v-model="narudzbenica_include_object_name"
                :value="true"
                :unchecked-value="false"
              >
                Prikaži ime objekta u polju "narudžbenica"
              </b-form-checkbox>
            </div>

            <hr class="my-4" />
            <h5 class="mb-3">Ariba integracija</h5>

            <div class="form-group">
              <b-form-checkbox
                :disabled="disabled"
                v-model="is_ariba_enabled"
                :value="true"
                :unchecked-value="false"
              >
                Omogući Ariba integraciju
              </b-form-checkbox>
            </div>
            <div class="form-group" v-if="is_ariba_enabled">
              <label>
                Ariba Buyer ANID
              </label>
              <b-form-input
                v-model="ariba_buyer_anid"
                :disabled="disabled"
                placeholder="npr. AN01051802448-T"
                id="ariba-buyer-anid-input"
                type="text"
              ></b-form-input>
            </div>
            <div class="form-group" v-if="is_ariba_enabled">
              <label>
                Klasifikacioni domen (APP, max 3)
              </label>
              <b-form-input
                v-model="classification_domain_app"
                :disabled="disabled"
                maxlength="3"
                placeholder="npr. C1"
                id="classification-domain-app-input"
                type="text"
              ></b-form-input>
            </div>
            <div class="form-group" v-if="is_ariba_enabled">
              <label>
                Klasifikacioni domen (Ariba)
              </label>
              <b-form-input
                v-model="classification_domain_ariba"
                :disabled="disabled"
                maxlength="50"
                placeholder="npr. CUSTOM"
                id="classification-domain-ariba-input"
                type="text"
              ></b-form-input>
            </div>

            <div class="text-right mb-2">
              <change-password-modal
                buttonClass=""
                :administratorId="this.$route.params.id"
              />
              <confirmation-modal
                buttonClass="mr-2"
                variant="danger"
                message="Da li ste sigurni da želite da izbrišete administratora?"
                title="Izbriši administratora"
                buttonText="Izbriši"
                @onSubmit="deleteAdministrator"
              />
              <b-button type="button" variant="secondary" @click="cancel()"
                >Otkaži</b-button
              >
              <b-button
                type="submit"
                variant="primary"
                :disabled="disabled"
                class="ml-2"
                >Snimi</b-button
              >
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>
input[type="radio"] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease 0.3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px;
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #ff5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #ffc107;
}

.lime .button span {
  background: #8bc34a;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196f3;
}

.indigo .button span {
  background: #3f51b5;
}
</style>
